import { checkAndGetValue, getFormattedCounterNumber } from './utils';

export { getFormattedCounterNumber };

export enum COUNTER_REDUCER_ACTION_KIND {
    INCREMENT = 'Increment',
    DECREMENT = 'Decrement',
    SET_VALUE = 'SetValue',
    CHECK_VALUE = 'CheckValue',
    CLEAR = 'Clear',
    SET_STATE = 'SetState'
}
type CounterReducerAction =
    | { type: COUNTER_REDUCER_ACTION_KIND.INCREMENT; payload?: never }
    | { type: COUNTER_REDUCER_ACTION_KIND.DECREMENT; payload?: never }
    | { type: COUNTER_REDUCER_ACTION_KIND.CHECK_VALUE; payload?: never }
    | { type: COUNTER_REDUCER_ACTION_KIND.CLEAR; payload?: never }
    | { type: COUNTER_REDUCER_ACTION_KIND.SET_VALUE; payload: string }
    | { type: COUNTER_REDUCER_ACTION_KIND.SET_STATE; payload: CounterReducerState };

export type CounterReducerState = {
    quantity: number;
    formattedValue: string;
    min: number;
    max: number;
    step: number;
    quantityUnit?: string;
};

export const counterReducer = (state: CounterReducerState, action: CounterReducerAction): CounterReducerState => {
    const { type, payload } = action;
    const { step, quantity } = state;

    switch (type) {
        case COUNTER_REDUCER_ACTION_KIND.INCREMENT: {
            return {
                ...state,
                ...checkAndGetValue({ ...state, quantity: quantity + step })
            };
        }
        case COUNTER_REDUCER_ACTION_KIND.DECREMENT: {
            return {
                ...state,
                ...checkAndGetValue({ ...state, quantity: quantity - step })
            };
        }
        case COUNTER_REDUCER_ACTION_KIND.SET_VALUE: {
            const valueAsNumber = parseInt(payload.replace('.', ''), 10);
            const newQuantity = valueAsNumber || step;
            const newFormattedValue = valueAsNumber ? valueAsNumber.toString() : '';

            return {
                ...state,
                quantity: newQuantity,
                formattedValue: newFormattedValue
            };
        }
        case COUNTER_REDUCER_ACTION_KIND.CHECK_VALUE: {
            return {
                ...state,
                ...checkAndGetValue(state)
            };
        }
        case COUNTER_REDUCER_ACTION_KIND.CLEAR: {
            return {
                ...state,
                formattedValue: ''
            };
        }
        case COUNTER_REDUCER_ACTION_KIND.SET_STATE: {
            return {
                ...state,
                ...payload
            };
        }
        default:
            return state;
    }
};
